import React from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

//model
import NinjaModel from "../../Models/ninja.glb";

//global variable
var scene;
var camera;
let controls;
var renderer;

let camX = 0;
let camY = 15;
let camZ = 290;
let angle = 0;

class HomeModel extends React.Component {
  componentDidMount() {
    //code
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 10000);
    // camera.position.set(0, 15, 190);
    this.setCamera(camX, camY, camZ);
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, canvas: document.querySelector("#ninjamodel") });
    renderer.setClearColor(0xffffff, 0);

    renderer.shadowMap.enabled = true;

    renderer.setSize(window.innerWidth, window.innerHeight);

    controls = new OrbitControls(camera, renderer.domElement);
    // controls.maxZoom = 1000;
    // controls.minZoom = 0;
    controls.enableZoom = false;
    controls.enablePan = false;
    controls.maxPolarAngle = Math.PI / 2;
    controls.minPolarAngle = Math.PI / 2.3;
    // controls.maxAzimuthAngle = 0.25;
    // controls.minAzimuthAngle = -0.2;
    // controls.minDistance = 5;
    // controls.maxDistance = 280;
    scene.add(controls);

    const light = new THREE.AmbientLight("#ffffff", 1);
    scene.add(light);
    let light1;

    if (window.innerWidth <= 500) {
      light1 = new THREE.PointLight("#ffffff", 2, 40);
      light1.position.set(10, 90, -50);
      controls.enabled = false;
    } else {
      light1 = new THREE.PointLight("#ffffff", 10, 40);
      light1.position.set(12, 30, 30);
    }
    scene.add(light1);

    this.loadModel();
    //function call
    this.GameLoop();
  }

  setCamera(camX, camY, camZ) {
    camera.position.set(camX, camY, camZ);
  }

  //run game loop(update,render,repeat)
  GameLoop = () => {
    requestAnimationFrame(this.GameLoop);
    this.update();
    this.renderScene();
  };

  //draw or display scene
  renderScene = () => {
    renderer.render(scene, camera);
  };

  update = () => {
    const ninja = scene.getObjectByName("model");
    if (ninja) {
      ninja.rotation.y += 0.005;
    }
  };

  loadModel = () => {
    const loader = new GLTFLoader();
    loader.load(
      NinjaModel,
      // onLoad
      (gltf) => {
        const model = gltf.scene;
        model.traverse((obj) => {
          if (obj.isMesh)
            if (obj.name === "bust_BustM_0") {
              const map = obj.material.map;
              const material = new THREE.MeshPhysicalMaterial({
                map: map,
                opacity: 1,
              });
              obj.material = material;
            }
        });
        model.name = "model";
        model.rotateY(angle);
        scene.add(model);
        // model.rotateX(-0.2);

        if (window.innerWidth <= 580) {
          model.scale.set(9, 10, 10);
          model.position.set(10, 20, -100);
          // model.position.set(10, 80, -100);
        } else {
          model.scale.set(22, 15, 20);
          model.position.set(5, 20, -70);
        }
      },

      // whileLoading
      (xhr) => console.log((xhr.loaded / xhr.total) * 100 + "% loaded"),

      // onError
      (error) => console.log("An error happened", error)
    );
  };

  render() {
    return (
      <div>
        <canvas id="ninjamodel"></canvas>
      </div>
    );
  }
}

export default HomeModel;
